import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "lexileap_token";

export function getToken() {
    try {
        return localStorage.getItem(TOKEN_KEY);
    } catch {
        return null;
    }
}
export function setToken(token) {
    try {
        if (token) localStorage.setItem(TOKEN_KEY, token);
        else localStorage.removeItem(TOKEN_KEY);
    } catch {
        /* storage disabled */
    }
}

export const api = axios.create({
    baseURL: API,
    timeout: 120000,
});

api.interceptors.request.use((config) => {
    const t = getToken();
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});

export function formatApiError(err) {
    const d = err?.response?.data?.detail;
    if (d == null) return err?.message || "Une erreur est survenue.";
    if (typeof d === "string") return d;
    if (Array.isArray(d))
        return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" · ");
    if (d && typeof d.msg === "string") return d.msg;
    return String(d);
}

/* ---------- constants used by onboarding ---------- */

export const LEVELS = [
    { code: "débutant", label: "Débutant complet" },
    { code: "A1", label: "A1 — Introduction" },
    { code: "A2", label: "A2 — Intermédiaire de base" },
    { code: "B1", label: "B1 — Intermédiaire" },
    { code: "B2", label: "B2 — Avancé" },
    { code: "C1", label: "C1 — Autonome" },
    { code: "C2", label: "C2 — Maîtrise" },
    { code: "inconnu", label: "Je ne sais pas — faire un test" },
];

// Plain CEFR codes only, used by the Phase 0 POC generator.
export const CEFR_LEVELS = ["A1", "A2", "B1", "B2", "C1", "C2"];

export const GOALS = [
    { code: "voyage", label: "Voyage", detail: "Se débrouiller en déplacement" },
    { code: "conversation", label: "Conversation", detail: "Échanger avec fluidité" },
    { code: "travail", label: "Travail", detail: "Emails, réunions, entretiens" },
    { code: "études", label: "Études", detail: "Suivre des cours ou lire" },
    { code: "examen", label: "Examen", detail: "TOEFL, DELE, JLPT…" },
    { code: "médical", label: "Spécialité — médical", detail: "Consultations, jargon clinique" },
    { code: "autre", label: "Autre", detail: "À préciser" },
];

export const DAILY_MINUTES = [5, 10, 20, 30, 60];
export const INTENSITY_WORDS = [10, 25, 50, 100];

export const MODALITIES = [
    { code: "écoute", label: "Écoute" },
    { code: "lecture", label: "Lecture" },
    { code: "conversation", label: "Conversation" },
    { code: "jeux", label: "Jeux" },
    { code: "multimodal", label: "Multimodal" },
];

export const CORRECTIONS = [
    { code: "douce", label: "Douce", detail: "On avance, on nuance après" },
    { code: "standard", label: "Standard", detail: "Corrections systématiques" },
    { code: "intensive", label: "Intensive", detail: "On ne laisse rien passer" },
];

export const INTEREST_SUGGESTIONS = [
    "cinéma", "cuisine", "voyage", "musique", "sport", "science", "art",
    "histoire", "tech", "littérature", "podcasts", "jeux vidéo", "mode", "nature",
    "philosophie", "actualités", "business",
];

export const PROGRAM_LENGTHS = [
    { days: 7, label: "7 jours — sprint" },
    { days: 30, label: "30 jours — routine" },
    { days: 90, label: "90 jours — transformation" },
];

/* ---------- Phase 0 POC constants (kept for /poc) ---------- */

export const TARGET_LANGUAGES = [
    { label: "anglais", flag: "🇬🇧" },
    { label: "espagnol", flag: "🇪🇸" },
    { label: "allemand", flag: "🇩🇪" },
    { label: "italien", flag: "🇮🇹" },
    { label: "portugais", flag: "🇵🇹" },
    { label: "japonais", flag: "🇯🇵" },
    { label: "arabe", flag: "🇸🇦" },
    { label: "russe", flag: "🇷🇺" },
    { label: "chinois", flag: "🇨🇳" },
    { label: "coréen", flag: "🇰🇷" },
    { label: "néerlandais", flag: "🇳🇱" },
    { label: "suédois", flag: "🇸🇪" },
    { label: "polonais", flag: "🇵🇱" },
    { label: "turc", flag: "🇹🇷" },
    { label: "hindi", flag: "🇮🇳" },
];

export const THEMES = [
    "nourriture",
    "voyage",
    "travail",
    "famille",
    "sport",
    "santé",
    "technologie",
    "nature",
    "école",
    "vêtements",
];
